<script lang="ts">
	import Layout from "../components/Layout.svelte";
	import { getTenant } from "../getTenant.js";
	import translations from "./Solutions.translations.json";
	import arrowRight from "../../../core/assets/icons/arrow-right.svg?raw";
	import Link from "../components/Link.svelte";
	import { getTranslate } from "../utils/getTranslate.js";
	import { contactPathMap } from "../../../core/schema/paths/contactPathMap";
	import { softwarePathMap } from "../../../core/schema/paths/softwarePathMap.js";
	import ContactForm from "../components/Contact/ContactForm.svelte";
	import ComputerSection from "../components/ComputerSection.svelte";
	import SolutionsSection from "../components/SolutionsSection.svelte";

	const translate = getTranslate(translations);
	const tenant = getTenant();
</script>

<Layout>
	<div class="container">
		<section class="mx-4 pb-6 md:mx-0 md:pb-24">
			<div class="flex items-center gap-4 md:mx-16 xl:mx-32">
				<span class="bg-ltprimary-200 h-px w-8"></span>
				<span class="text-ltprimary-200 uppercase">{translate("tag")}</span>
			</div>
			<div class="mt-16 flex flex-col gap-8 md:mx-16 md:gap-12 xl:mx-32 xl:flex-row xl:gap-32">
				<div class="w-full md:max-w-3xl">
					<h1
						class="text-ltprimary w-full p-0 text-center font-light uppercase tracking-wider md:max-w-[39.8125rem] md:text-left"
					>
						{translate("introductoryHeadline")}
					</h1>
				</div>
				<div class="text-ltsecondary max-w-3xl flex-1">
					<div class="lg:text-md/normal mb-5 tracking-[0.02em]">{translate("introductoryDesc1")}</div>
					<div class="lg:text-md/normal mb-5 tracking-[0.02em]">{translate("introductoryDesc2")}</div>
					<Link asButton variant="secondary" class="mt-16" icon={arrowRight} href="/{contactPathMap[tenant.locale]}"
						>{translate("contactUs")}</Link
					>
				</div>
			</div>
		</section>
	</div>
	<div class="mt-8 md:mt-0">
		<SolutionsSection headingLevel={2} />
	</div>
	<div class="container">
		<section class="mt-16 lg:mt-24">
			<ComputerSection>
				<div class="mb-4 lg:mb-8">
					<h2
						class="text-ltprimary xl:text- mt-12 items-start text-center font-light uppercase tracking-[0.02em] md:text-left xl:mt-0"
					>
						{translate("headline")}
					</h2>
				</div>
				<p class="text-ltsecondary font-lexend !text-md mx-auto max-w-3xl font-light tracking-[0.02em]">
					{translate("desc")}
				</p>
				<div class="mt-3 flex lg:mt-4 xl:mt-11">
					<Link asButton variant="secondary" icon={arrowRight} href="/{softwarePathMap[tenant.locale]}">
						{translate("moreAbout")}
					</Link>
				</div>
			</ComputerSection>
		</section>
	</div>

	<section class="!mb-0">
		<ContactForm />
	</section>
</Layout>
